var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShowReply)?_c('span',{staticClass:"cometchat__replycount",style:(_vm.styles),on:{"click":function($event){return _vm.emitAction('viewMessageThread', { message: _vm.message })}}},[_vm._v(" "+_vm._s(_vm.replyText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }